import * as actionTypes from '../Actions/ActionTypes'

const initialState = {
  list: [],
}

const getCategoriesSuccess = (state, action) => {
  let { categories } = action.payload

  return {
    ...state,
    list: categories,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CATEGORIES_SUCCESS:
      return getCategoriesSuccess(state, action)

    default:
      return state
  }
}

export default reducer
